/**
 * Specs Table Cleanup
 * ===================
 * Normalizes product spec tables by:
 *   1. Hiding empty-value rows that duplicate a filled row with the same label
 *      (e.g. "Body" with no value vs "Body: Basswood").
 *   2. Hiding "Refinement X" rows when a matching "X" row exists with same value
 *      (Fender taxonomy pollution).
 *   3. Hiding shorter-label rows when a longer-label row contains the same
 *      words + same value (e.g. "Configuration: HSS" hidden in favor of
 *      "Pickup Configuration: HSS").
 *   4. Removing fully empty rows.
 *   5. Marking unique empty-value rows as "spec-section-header" for CSS styling.
 */
(function () {
  'use strict';
  function normalize(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function normLower(s) { return normalize(s).toLowerCase(); }

  function run(root) {
    root = root || document;
    var tables = root.querySelectorAll('.product-bottom-tabs__specs-content table, .product-bottom-tabs__panel--specs table');
    tables.forEach(function (t) {
      var rows = Array.prototype.slice.call(t.querySelectorAll('tr'));

      // First pass: collect { label_norm: [{ row, val_norm }, ...] }
      var labelMap = {};
      rows.forEach(function (r) {
        var tds = r.querySelectorAll('td');
        if (tds.length < 2) return;
        var lab = normalize(tds[0].textContent);
        var val = normalize(tds[1].textContent);
        if (!lab) return;
        var key = normLower(lab);
        (labelMap[key] = labelMap[key] || []).push({ row: r, val: val, valLower: normLower(val) });
      });

      // Second pass: decide hide/keep per row
      rows.forEach(function (r) {
        var tds = r.querySelectorAll('td');
        if (tds.length < 2) {
          if (!normalize(r.textContent)) r.style.display = 'none';
          return;
        }
        var lab = normalize(tds[0].textContent);
        var val = normalize(tds[1].textContent);

        // Fully empty row
        if (!lab && !val) { r.style.display = 'none'; return; }

        // Empty-value row: section header OR duplicate of filled row with same label
        if (lab && !val) {
          var labKey = normLower(lab);
          var entries = labelMap[labKey] || [];
          var hasFilled = entries.some(function (e) { return e.val; });
          if (hasFilled) {
            r.style.display = 'none';           // duplicate header/spec
          } else {
            r.classList.add('spec-section-header');
          }
          return;
        }

        // "Refinement X" rows: hide if a matching "X" row exists with same value
        if (lab && val) {
          var refMatch = /^refinement\s+(.+)$/i.exec(lab);
          if (refMatch) {
            var baseLabel = normLower(refMatch[1]);
            var baseEntries = labelMap[baseLabel] || [];
            var sameVal = baseEntries.some(function (e) { return e.val && e.valLower === normLower(val); });
            if (sameVal) { r.style.display = 'none'; return; }
          }

          // Shorter-label redundancy: hide if a LONGER label containing this
          // label as a suffix has the same value.
          // Example: "Configuration: HSS" hidden when "Pickup Configuration: HSS" exists.
          // SKIP when the longer label starts with "Refinement " — we want to
          // keep the base and hide the Refinement variant (handled by Rule 2).
          var labWords = lab.split(/\s+/);
          if (labWords.length <= 2) {
            var valLower = normLower(val);
            var keys = Object.keys(labelMap);
            for (var i = 0; i < keys.length; i++) {
              var otherKey = keys[i];
              if (otherKey === labWords.join(' ').toLowerCase()) continue;
              if (/^refinement\s/.test(otherKey)) continue;  // skip Refinement variants
              var pat = new RegExp('(^|\\s)' + lab.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '$');
              if (pat.test(otherKey)) {
                var otherEntries = labelMap[otherKey] || [];
                var otherSameVal = otherEntries.some(function (e) { return e.valLower === valLower; });
                if (otherSameVal) { r.style.display = 'none'; return; }
              }
            }
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[role="tab"]')) {
      setTimeout(run, 50);
    }
  });
})();
